import React from 'react';
import { Link } from "react-router-dom";
import { Layout, Row, Col } from 'antd';
import {
  FacebookOutlined,
  TwitterOutlined,
  LinkedinOutlined,
    InstagramOutlined,
    MailOutlined,
    PhoneOutlined,
    EnvironmentOutlined
} from '@ant-design/icons';
import { FaRocket, FaGraduationCap, FaShieldAlt } from 'react-icons/fa';

const { Footer: AntFooter } = Layout;

const Footer = ({ footer }) => {
  return <DefaultFooter />;
};

export default Footer;

const DefaultFooter = () => (
    <AntFooter className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 pt-20 pb-8">
        <div className="container mx-auto px-4">
            <Row justify="space-between" gutter={[32, 32]}>
                {/* Company Info */}
                <Col xs={24} sm={12} md={6}>
                    <Link to="/" className="inline-block mb-4">
            <img
              src="/assets/logo/logo.png"
                            alt="Educational Eternity Logo"
                            title="Educational Eternity"
                            className="h-16 object-contain rounded-full"
            />
          </Link>
                    <p className="text-gray-300 mb-4 leading-relaxed">
                        Revolutionizing Education with Smart & Seamless Digital Solutions! Empowering institutions with AI-powered ERP systems.
          </p>
                    <div className="flex space-x-4 text-gray-400">
                        <a 
                            href="https://www.facebook.com/share/1VDc3Kc4Q7/"
            target="_blank"
            rel="noopener noreferrer"
                            className="text-2xl hover:text-blue-500 transition-colors duration-300"
                            aria-label="Facebook"
            >
              <FacebookOutlined />
            </a>
                        <a 
                            href="#"
                            className="text-2xl hover:text-blue-400 transition-colors duration-300"
                            aria-label="Twitter"
                        >
              <TwitterOutlined />
            </a>
                        <a 
                            href="#"
                            className="text-2xl hover:text-blue-600 transition-colors duration-300"
                            aria-label="LinkedIn"
                        >
              <LinkedinOutlined />
            </a>
            <a
              href="https://www.instagram.com/educationaleternity"
              target="_blank"
              rel="noopener noreferrer"
                            className="text-2xl hover:text-pink-500 transition-colors duration-300"
                            aria-label="Instagram"
            >
              <InstagramOutlined />
            </a>
          </div>
        </Col>

                {/* Quick Links */}
                <Col xs={24} sm={12} md={6}>
                    <h4 className="text-xl font-bold text-white mb-6 flex items-center gap-2">
                        <FaRocket className="text-blue-400" /> Quick Links
                    </h4>
                    <ul className="list-none space-y-3">
                        <li>
                            <Link to="/" className="text-gray-300 hover:text-blue-400 transition-colors duration-300 flex items-center gap-2">
                                <span className="w-2 h-2 bg-blue-400 rounded-full"></span>
                                Home
                            </Link>
                        </li>
                        <li>
                            <Link to="/features" className="text-gray-300 hover:text-blue-400 transition-colors duration-300 flex items-center gap-2">
                                <span className="w-2 h-2 bg-blue-400 rounded-full"></span>
                                Features
                            </Link>
                        </li>
                        <li>
                            <Link to="/solutions" className="text-gray-300 hover:text-blue-400 transition-colors duration-300 flex items-center gap-2">
                                <span className="w-2 h-2 bg-blue-400 rounded-full"></span>
                                Solutions
                            </Link>
                        </li>
                        <li>
                            <Link to="/services" className="text-gray-300 hover:text-blue-400 transition-colors duration-300 flex items-center gap-2">
                                <span className="w-2 h-2 bg-blue-400 rounded-full"></span>
                                Services
                            </Link>
                        </li>
                        <li>
                            <Link to="/about" className="text-gray-300 hover:text-blue-400 transition-colors duration-300 flex items-center gap-2">
                                <span className="w-2 h-2 bg-blue-400 rounded-full"></span>
                                About Us
                            </Link>
                        </li>
                        <li>
                            <Link to="/plans" className="text-gray-300 hover:text-blue-400 transition-colors duration-300 flex items-center gap-2">
                                <span className="w-2 h-2 bg-blue-400 rounded-full"></span>
                                Pricing Plans
                            </Link>
                        </li>
                        <li>
                            <Link to="/contact" className="text-gray-300 hover:text-blue-400 transition-colors duration-300 flex items-center gap-2">
                                <span className="w-2 h-2 bg-blue-400 rounded-full"></span>
                                Contact Us
                            </Link>
                        </li>
                        <li>
                            <Link to="/gallery" className="text-gray-300 hover:text-blue-400 transition-colors duration-300 flex items-center gap-2">
                                <span className="w-2 h-2 bg-blue-400 rounded-full"></span>
                                Gallery
                            </Link>
                        </li>
                    </ul>
                </Col>

                {/* Resources */}
                <Col xs={24} sm={12} md={6}>
                    <h4 className="text-xl font-bold text-white mb-6 flex items-center gap-2">
                        <FaGraduationCap className="text-blue-400" /> Resources
                    </h4>
                    <ul className="list-none space-y-3">
                        <li>
                            <Link to="/blog" className="text-gray-300 hover:text-blue-400 transition-colors duration-300 flex items-center gap-2">
                                <span className="w-2 h-2 bg-blue-400 rounded-full"></span>
                                Blog
                            </Link>
                        </li>
                        <li>
                            <Link to="/testimonials" className="text-gray-300 hover:text-blue-400 transition-colors duration-300 flex items-center gap-2">
                                <span className="w-2 h-2 bg-blue-400 rounded-full"></span>
                                Testimonials
                            </Link>
                        </li>
                        <li>
                            <Link to="/faq" className="text-gray-300 hover:text-blue-400 transition-colors duration-300 flex items-center gap-2">
                                <span className="w-2 h-2 bg-blue-400 rounded-full"></span>
                                FAQ
                            </Link>
                        </li>
                        <li>
                            <Link to="/case-studies" className="text-gray-300 hover:text-blue-400 transition-colors duration-300 flex items-center gap-2">
                                <span className="w-2 h-2 bg-blue-400 rounded-full"></span>
                                Case Studies
                            </Link>
                        </li>
                        <li>
                            <Link to="/gallery" className="text-gray-300 hover:text-blue-400 transition-colors duration-300 flex items-center gap-2">
                                <span className="w-2 h-2 bg-blue-400 rounded-full"></span>
                                Gallery
                            </Link>
                        </li>
          </ul>
        </Col>

                {/* Contact Info */}
                <Col xs={24} sm={12} md={6}>
                    <h4 className="text-xl font-bold text-white mb-6 flex items-center gap-2">
                        <FaShieldAlt className="text-blue-400" /> Contact Us
                    </h4>
                    <ul className="list-none space-y-4">
                        <li className="flex items-start gap-3">
                            <MailOutlined className="text-blue-400 text-xl mt-1" />
                            <a 
                                href="mailto:admin@educationaleternity.com" 
                                className="text-gray-300 hover:text-blue-400 transition-colors duration-300"
                            >
                                admin@educationaleternity.com
                            </a>
                        </li>
                        <li className="flex items-start gap-3">
                            <PhoneOutlined className="text-blue-400 text-xl mt-1" />
                            <div className="text-gray-300">
                               
                                <a href="tel:9934001660" className="hover:text-blue-400 transition-colors duration-300 block">
                                    9934001660
                                </a>
                                <a href="tel:7654108215" className="hover:text-blue-400 transition-colors duration-300 block">
                                    7654108215
                                </a>
                            </div>
                        </li>
                        <li className="flex items-start gap-3">
                            <EnvironmentOutlined className="text-blue-400 text-xl mt-1" />
                            <div className="text-gray-300">
                                <p>NH-28 shiv mandir Near Khabra</p>
                                <p>Resonance international school</p>
                                <p>Muzaffarpur, Bihar, 842002</p>
                                <p>India</p>
                            </div>
                        </li>
          </ul>
        </Col>
      </Row>
            
            {/* Bottom Bar */}
            <div className="mt-12 pt-8 border-t border-gray-700">
                <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="text-gray-400 text-center md:text-left">
                        © {new Date().getFullYear()} Educational Eternity. All rights reserved.
                    </p>
                    <div className="flex gap-6 text-gray-400 text-sm">
                        <Link to="/" className="hover:text-blue-400 transition-colors duration-300">
                            Privacy Policy
                        </Link>
                        <Link to="/" className="hover:text-blue-400 transition-colors duration-300">
                            Terms of Service
                        </Link>
                        <Link to="/" className="hover:text-blue-400 transition-colors duration-300">
                            Disclaimer
                        </Link>
                    </div>
                </div>
      </div>
    </div>
  </AntFooter>
);
